import { getCookie } from "./cookieUtils";

// Config uses a getter so the token is read from the cookie at request time,
// not once at module load — this ensures token refreshes are picked up automatically.
export const Config = {
  get headers() {
    return { Authorization: `Bearer ${getCookie('token')}` };
  },
};


